export default __webpack_public_path__ + "static/CharterITCW05-Bold-23efe5ea7bd1eb76c99c46ec904bab31.woff2";